import { z } from 'zod';

export const emailSchema = z.string().trim().toLowerCase().email('Adresse email invalide');

export const passwordSchema = z
  .string()
  .min(10, 'Le mot de passe doit faire au moins 10 caracteres')
  .max(200, 'Le mot de passe est trop long');

export const registerSchema = z.object({
  email: emailSchema,
  password: passwordSchema,
  displayName: z.string().trim().min(1, 'Le nom est obligatoire').max(100, 'Le nom est trop long'),
});

export const loginSchema = z.object({
  email: emailSchema,
  password: z.string().min(1, 'Le mot de passe est obligatoire'),
});

/** Demander un lien de reinitialisation. Seule l'adresse est necessaire. */
export const demandeReinitialisationSchema = z.object({ email: emailSchema });

/**
 * Utiliser le lien. Le jeton vient de l'URL de l'email ; le nouveau mot de passe est
 * soumis aux MEMES regles qu'a l'inscription — un mot de passe recupere n'est pas un
 * mot de passe au rabais.
 */
export const reinitialisationSchema = z.object({
  token: z.string().min(1, 'Lien invalide'),
  newPassword: passwordSchema,
});

export type RegisterInput = z.infer<typeof registerSchema>;
export type LoginInput = z.infer<typeof loginSchema>;
